<div class="banner" style="background-image: url('assets/{{ bannerImage }}');">
  <div class="titleBar">
    <div class="logoArea">
      <helena-logo-ppk></helena-logo-ppk>
      <h1>Tankmix</h1>
    </div>
    <app-navigation-helena></app-navigation-helena>
  </div>
 </div>
